import React from 'react';
/** @jsx jsx */
import { css, jsx } from '@emotion/core';

// import components
import MessageBoard from './DataProcessing.MessageBoard';
import SessionButtons from './DataProcessing.SessionButtons';
import SupportContents from './DataProcessing.SupportContents';

// import data
import {
  announcement,
  messageBoardItems,
  dataProcessingSupportMenu,
  dataProcessingCurrentUpdateItems,
  dataProcessingSessionDemonItems
} from "../assets/constants/home";



const DataProcessingTab = (props) => {
  // console.log(props);
  return (
    <div css={css`
      display: flex;
      flex-direction: column;
      flex-wrap: nowrap;
      justify-content: space-between;
      align-items: center;
      margin: 20px 0px;
      padding: 20px;
    `}>

      <MessageBoard 
        messageBoardItems = {messageBoardItems}
        announcement = {announcement} />

      <SessionButtons 
        list={props.list} />

      <SupportContents 
        menu={dataProcessingSupportMenu}
        dataProcessingCurrentUpdateItems={dataProcessingCurrentUpdateItems}
        dataProcessingSessionDemonItems={dataProcessingSessionDemonItems}
      />
    </div>
  )
}

export default DataProcessingTab;